import React from 'react';
import PropTypes from 'prop-types';

class OptionRow extends React.Component {
    render() {
        const {choiceCallback, filterOption, filterKey} = this.props;

        return (
            <li>
                <a className="filter__option" onClick={() => { choiceCallback(filterKey, filterOption.id) } }>{ filterOption.name }</a>
            </li>
        );
    }
}

OptionRow.propTypes = {
    choiceCallback: PropTypes.func.isRequired,
    filterOption: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            slug: PropTypes.string,
    }).isRequired,
    filterKey: PropTypes.string.isRequired,
};

export default OptionRow;